import { makeAutoObservable } from 'mobx'
import { type IResponseStatisticsClicksItem } from 'entities/ClickToText/api/type'

export type IClickToTextStatisticsClicks = ClickToTextStatisticsClicks

export class ClickToTextStatisticsClicks {
  private readonly _id: string
  private readonly _location: string
  private readonly _deviceType: string
  private readonly _linkOpenedAt: string

  constructor(item: IResponseStatisticsClicksItem, id: string) {
    this._id = id
    this._location = item.location
    this._deviceType = item.device_type
    this._linkOpenedAt = item.link_opened_at

    makeAutoObservable(this)
  }

  get id() {
    return this._id
  }
  get location() {
    return this._location
  }
  get deviceType() {
    return this._deviceType
  }
  get linkOpenedAt() {
    return this._linkOpenedAt
  }
}
